function logout() {
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("user");
  window.location.reload();
}

const getErrorMessage = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(getErrorMessage).filter(Boolean).join(", ");
  if (typeof value === "object") {
    if (typeof value.message === "string") return value.message;
    if (typeof value.msg === "string") return value.msg;
    const messages = Object.values(value).map(getErrorMessage).filter(Boolean);
    return [...new Set(messages)].join(", ");
  }
  return String(value);
};

export function handleResponse(response) {
  return response.text().then((text) => {
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) logout();

      const error = getErrorMessage(data && (data.err || data.error || data.errors || data.message))
        || response.statusText
        || "Request failed";
      return Promise.reject(error);
    }

    return Promise.resolve(data);
  });
}
